'use client';
import { useBrand } from '@curology/ui-components-web/brand/context';
import { AgencyLogoStickerIcon } from '@curology/ui-components-web/react/Icon/icons/AgencyLogoStickerIcon';
import { CurologyLogoStickerIcon } from '@curology/ui-components-web/react/Icon/icons/CurologyLogoStickerIcon';

import { type Brand } from '@/consts/brands';

const AgencyLoadingSpinner = (
  <AgencyLogoStickerIcon className="cur-animate-bounce" size="xl" />
);

const CurologyLoadingSpinner = (
  <CurologyLogoStickerIcon
    className="cur-opacity-40 cur-animate-bounce"
    size="xl"
  />
);

const IconMap: Record<Brand, React.ReactNode> = {
  agency: AgencyLoadingSpinner,
  curology: CurologyLoadingSpinner,
};

export const FullPageLoading = () => {
  const brand = useBrand();

  return (
    <div className="cur-h-full cur-w-full cur-flex cur-items-center cur-justify-center cur-grow">
      {IconMap[brand]}
    </div>
  );
};
